import type { PropsWithChildren } from "react";
import { Layout } from "antd";
import { createStyles } from "antd-style";

const useStyles = createStyles(({ token, css }) => {
  return {
    layoutContent: css`
      padding: ${token.padding}px;
      padding-top: ${token.paddingXL}px;
      box-sizing: border-box;
      position: relative;
      margin: 0 auto;
      max-width: 1400px;
      width: 100%;
      display: flex;
      justify-content: center;
      @media (max-width: ${token.screenMDMax}px) {
        margin-left: 0;
        margin-top: 0;
        height: 100vh;
      }
    `,
  };
});

export function JobsAppLayoutContent(props: PropsWithChildren) {
  const { styles } = useStyles();

  return (
    <Layout.Content color="default" className={styles.layoutContent}>
      {props.children}
    </Layout.Content>
  );
}
